import { useMemo } from 'react';

import { useCurrentCommunityAllowedRoutes } from 'shared/hooks';
import type { SidebarNavigationItemList } from 'shared/types';
import { sortLayoutRoutes } from 'shared/utils/url';

import { useCurrentUserRoles } from './useCurrentUserRoles';

export function useSidebarMenuItems() {
  const { isPlatformAdmin, loading: userSystemRolesLoading } = useCurrentUserRoles();
  const { authorizedRoutes, loading: authorizedRoutesLoading } = useCurrentCommunityAllowedRoutes();

  const loading = authorizedRoutesLoading || userSystemRolesLoading;

  const sidebarMenuItems = useMemo<SidebarNavigationItemList>(() => {
    if (authorizedRoutes.length === 0) {
      return [];
    }

    const authorizedRoutesSorted = sortLayoutRoutes(authorizedRoutes);

    return (
      authorizedRoutesSorted
        // Filter out inactive routes
        .filter(item => item.isActive)
        .map(item => ({
          name: item.name as string,
          route: item.route as string,
          icon: item.icon as string,
        }))
    );
  }, [authorizedRoutes, isPlatformAdmin]);

  return {
    sidebarMenuItems,
    /** @deprecated Use `loading` instead. */
    isLoading: loading,
    loading,
  };
}
